/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {CompletePreconditionsRequest} from '@cash-web/protos/squareup/privacyvault/service.pb'
import {CompletePreconditionsResponse} from '@cash-web/protos/squareup/privacyvault/service.pb'


export const completePreconditions = (request: CompletePreconditionsRequest, options?: CashRequestOptions) => post<CompletePreconditionsRequest, CompletePreconditionsResponse>("/2.0/cash/complete-preconditions", request, {...options, rejectOnError: true })